import { KeyValue } from "../models/KeyValue";

export const BANKS: KeyValue[] = [
	{ key: "SEB", value: "SEB" },
	{ key: "HANDELSBANKEN", value: "Handelsbanken" },
	{ key: "SWEDBANK", value: "Swedbank" },
	{ key: "NORDEA", value: "Nordea" },
	{ key: "IKANO_BANK", value: "Ikano Bank" },
	{ key: "LANSFORSAKRINGAR_BANK", value: "Länsförsäkringar bank" },
	{ key: "SKANDIABANKEN", value: "Skandiabanken" },
	{ key: "SPARBANKEN", value: "Sparbanken" },
	{ key: "ICA_BANKEN", value: "Ica banken" },
	{ key: "DANSKE_BANK", value: "Danske bank" },
	{ key: "OTHER", value: "Övrigt" },
];
